<template>
  <div class="small-4 medium-4 large-4 columns">
    <div class="row tabuladores_noticias">
      <div class="small-6 medium-6 large-6 columns tab_noticias tab1_noticias"
        :class="{ active: currentTab == 'recent' }">
        <a @click="changeTabView('recent')">
          {{ $t("UMA_LANG_MAISRECENTES") }}
        </a>
      </div>
      <div class="small-6 medium-6 large-6 columns tab_noticias tab2_noticias"
        :class="{ active: currentTab == 'mostviewed' }">
        <a @click="changeTabView('mostviewed')">
          {{ $t("UMA_LANG_MAISACEDIDAS") }}
        </a>
      </div>
    </div>
    <div class="row ultimos_conteudos">
      <div id="listaRecente" v-show="currentTab == 'recent'">
        <template v-for="news in recentNews">
          <a @click="fetchNewNoticia(news)" class="titulo_noticia_investigacao">
            {{ news.noticia_titulo }}
          </a>
          <p>
            {{ $t("UMA_LANG_DATAPUB") }}: {{ news.noticia_data_publicacao }}
          </p>
          <span class="linha_ultimos_conteudos"></span>
        </template>
      </div>
      <div id="listaAcedidas" v-show="currentTab == 'mostviewed'">
        <template v-for="news in mostViewed">
          <a @click="fetchNewNoticia(news)" class="titulo_noticia_investigacao">
            {{ news.noticia_titulo }}
          </a>
          <p>
            {{ $t("UMA_LANG_DATAPUB") }}: {{ news.noticia_data_publicacao }}
          </p>
          <span class="linha_ultimos_conteudos"></span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { ref } from "vue";
import { i18n } from "@/main.js";
import { useRouter } from 'vue-router';

export default {
  setup() {

    const lang = i18n.global.locale;

    const mostViewed = ref([]);
    const recentNews = ref([]);

    const getMostViewed = () => {
      axios.get(`/noticiassas/mostviewed?limit=8&idioma=${lang}`).
        then(response => {
          mostViewed.value = response.data;
        }).catch(error => {
            console.log(error);
        });
    }

    getMostViewed()

    const getRecentNews = () => {
      const parameters = `limit=8&publicado=1&idioma=${lang}&owner=${import.meta.env.VITE_APP_OWNER}&sort=noticia_data_publicacao`;
      axios.get(`/noticiassas?${parameters}`).
        then(response => {
          recentNews.value = response.data.data;
        }).catch(error => {
            console.log(error);
        });
    }

    getRecentNews()

    const currentTab = ref("recent")
    const changeTabView = (tab) => {
      currentTab.value = tab
    }

    const router = useRouter();
    const fetchNewNoticia = (noticia) => {
      router.push({path: `/noticiassas/${noticia.noticia_name}`});
    }


    return {
      fetchNewNoticia,
      changeTabView,
      currentTab,
      recentNews,
      mostViewed,
    }
  }
}
</script>

<style lang="scss" scoped>
/*tabuladores*/
.tab_noticias.active {
  background-color: white;
}

.tabuladores_noticias a,
.tabuladores_noticias p {
  margin-left: 20px;
  display: inline-flex;
  font-size: 14px;
  padding-top: 30px;
  padding-bottom: 10px;
  text-transform: uppercase;
  font-family: "Montserrat Bold";
  letter-spacing: 0.15px;
  color: #333333;
  margin-bottom: 1rem;
}

.ultimos_conteudos {
  background-color: white;
}

.hidelist {
  display: none;
}

.ultimos_conteudos h1,
.ultimos_conteudos a {
  font-family: "Montserrat Bold";
  font-size: 18px;
  padding-right: 40px;
  padding-left: 35px;
  width: 100%;
  display: block;
  color: #333333;
  margin-bottom: 0.5rem;
}

.ultimos_conteudos h1:first-child,
.ultimos_conteudos a:first-child {
  padding-top: 45px;
}

.ultimos_conteudos p {
  font-family: PT Sans Italic;
  color: #c0bfc9;
  margin-bottom: 20px;
  padding-left: 35px;
  font-size: 15px;
}

.linha_ultimos_conteudos {
  border-bottom: 1px solid #D3D3D3;
  margin-bottom: 30px;
  margin-left: 35px;
  margin-right: 39px;
  display: block;
}

.linha_ultimos_conteudos:last-child {
  border-bottom: 1px solid transparent;
}

.linha_separador {
  border-bottom: 1px solid #D3D3D3;
  padding-top: 75px;
  padding-bottom: 120px;
}

@media (max-width: 1024px) {
  .noticiadetalhe .tabuladores_noticias {
    display: none;
  }

  .noticiadetalhe .ultimos_conteudos {
    display: none;
  }
}

@media (max-width: 767px) {
  .noticiadetalhe .tabuladores_noticias {
    display: none;
  }

  .noticiadetalhe .ultimos_conteudos {
    display: none;
  }
}
</style>